export default __webpack_public_path__ + "static/media/EmptyGreyCircle.97c2e114.svg";